import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { BrandMark, Icon } from '../ui/index.js';
import { useAuth } from '../auth/AuthContext.js';
import { BlurToggle } from './BlurToggle.js';
import { InstallBanner } from './InstallBanner.js';
import { ThemeToggle } from './ThemeToggle.js';
import { UploadDock } from './UploadDock.js';

const PUBLIC_ROUTES = new Set(['/login', '/signup', '/auth/callback']);

export function Layout() {
  const location = useLocation();
  const isPublic = PUBLIC_ROUTES.has(location.pathname);

  return (
    <div className="flex min-h-screen flex-col">
      {isPublic ? <PublicTopBar /> : <AppTopBar />}
      <main
        className={
          isPublic
            ? 'flex w-full flex-grow flex-col items-center px-5 pt-24 pb-12 sm:px-6'
            : 'mx-auto w-full max-w-7xl flex-grow px-5 py-6 sm:px-6 sm:py-8'
        }
      >
        <Outlet />
      </main>
      <UploadDock />
      <InstallBanner />
    </div>
  );
}

function AppTopBar() {
  const navigate = useNavigate();
  const { session, signOut } = useAuth();

  async function handleSignOut() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <header className="glass-vault sticky top-0 z-40 w-full border-b border-outline">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-5 py-3 sm:px-6">
        <Link to="/" className="flex items-center gap-3 text-on-surface">
          <BrandMark showWordmark />
        </Link>
        <div className="flex items-center gap-1.5 sm:gap-2">
          {session ? (
            <Link
              to="/search"
              className="inline-flex h-10 items-center gap-2 rounded-xl border border-outline bg-surface-container-lowest px-3 text-xs font-semibold uppercase tracking-[0.12em] text-on-surface-variant transition-all hover:border-on-surface-variant/40 hover:text-cyan sm:px-3.5"
              aria-label="Cerca"
            >
              <Icon name="search" className="text-base" />
              <span className="hidden sm:inline">Cerca</span>
            </Link>
          ) : null}
          <ThemeToggle />
          {session ? <BlurToggle /> : null}
          {session ? (
            <button
              type="button"
              onClick={handleSignOut}
              className="inline-flex h-10 items-center gap-2 rounded-xl border border-outline bg-surface-container-lowest px-3 text-xs font-semibold uppercase tracking-[0.12em] text-on-surface-variant transition-all hover:border-on-surface-variant/40 hover:text-cyan sm:px-3.5"
              aria-label="Esci"
            >
              <Icon name="lock" className="text-base" />
              <span className="hidden sm:inline">Lock</span>
            </button>
          ) : null}
        </div>
      </div>
    </header>
  );
}

function PublicTopBar() {
  return (
    <header className="absolute inset-x-0 top-0 z-40 px-5 py-5 sm:px-6">
      <div className="mx-auto flex w-full max-w-md items-center justify-between">
        <Link to="/" className="text-on-surface" aria-label="Photo Vault">
          <BrandMark />
        </Link>
        <ThemeToggle />
      </div>
    </header>
  );
}
